import { useAuthSession } from '@modeling/account';
import { message } from 'antd';
import { GitCredentialsPage as GitCredentialsForm } from '@modeling/git-file-viewer';
import { resolveGitApiBaseUrl } from '../../api/env';
import './GitCredentialsSetup.css';

export interface GitCredentialsSetupProps {
  repoUrl: string;
  hint?: string;
  onConfigured?: () => void;
}

function useGitCredentialsHandlers(onConfigured?: () => void) {
  const session = useAuthSession();
  const baseURL = resolveGitApiBaseUrl();

  const getAuthHeaders = (): Record<string, string> => {
    const token = session.token ?? '';
    return {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
  };

  const onMessage = (type: 'info' | 'success' | 'warning' | 'error', text: string) => {
    switch (type) {
      case 'success':
        message.success(text);
        break;
      case 'warning':
        message.warning(text);
        break;
      case 'error':
        message.error(text);
        break;
      default:
        message.info(text);
    }
  };

  return {
    baseURL,
    getAuthHeaders,
    onMessage,
    onSaved: onConfigured,
  };
}

/** Schema / Git 页内嵌的凭据配置表单 */
export function GitCredentialsSetup({ repoUrl, hint, onConfigured }: GitCredentialsSetupProps) {
  const { baseURL, getAuthHeaders, onMessage, onSaved } = useGitCredentialsHandlers(onConfigured);

  return (
    <div className="git-credentials-setup git-file-viewer-theme-root">
      {hint ? <p className="git-credentials-setup-hint">{hint}</p> : null}
      <GitCredentialsForm
        baseURL={baseURL}
        initialPath={repoUrl}
        getAuthHeaders={getAuthHeaders}
        onMessage={onMessage}
        onSaved={onSaved}
      />
    </div>
  );
}
